module.exports = __webpack_public_path__ + "img/leaderboard.8661203f.svg";